import { Ability } from "@casl/ability"

export const ability = new Ability()

export function abilityPlugin(store) {
  // Transform deprecated 'actions' field to 'action' for backward compatibility
  const rules = store.state.auth.rules || []
  const transformedRules = rules.map((rule) => {
    if (rule && rule.actions && !rule.action) {
      const { actions, ...rest } = rule
      return { ...rest, action: actions }
    }
    return rule
  })
  ability.update(transformedRules)

  return store.subscribe((mutation) => {
    switch (mutation.type) {
      case "auth/loginSuccess": {
        let formattedRules = []
        if (mutation.payload.userInfo.modules.length > 0) {
          formattedRules = mutation.payload.userInfo.modules.map((perm) => {
            const formattedObj = {}
            formattedObj.action = perm
            formattedObj.subject = "permissions"
            return formattedObj
          })
        }
        ability.update(formattedRules)
        break
      }
      case "auth/logoutSuccess":
        ability.update([{ action: "read", subject: "all" }])
        break
      default:
        // No action needed for other mutations
        break
    }
  })
}
